import React, {FC, useState} from 'react'

type Props = {
  handleSelectFile: any
}

const UploadFotoProfileContent: FC<Props> = ({handleSelectFile}) => {
  const [file, setFile] = useState<any>({})
  const [errors, setErrors] = useState<any>({})

  const handleChangeFile = (e: any) => {
    handleSelectFile(e.target.files[0])
    setFile(e.target.files[0])
    setErrors({})
  }

  return (
    <div>
      <div
        className='d-flex justify-content-between border rounded p-4'
        style={{cursor: 'pointer', backgroundColor: '#F4F7FE'}}
      >
        <label className='fw-bold' style={{cursor: 'pointer'}}>
          <i className='bi bi-upload text-black'></i> Upload Foto
          <input
            type='file'
            id='input-file-avatar'
            style={{display: 'none'}}
            name='GeneralImages'
            onChange={handleChangeFile}
            accept='.jpg,.jpeg,.png' // hanya izinkan jpg & png
          />
        </label>
      </div>

      <p
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        }}
      >
        {file?.name}
      </p>

      <div className='text-muted mt-3'>
        <p>Gunakan foto formal dan profesional dengan ketentuan berikut:</p>
        <p>📏 Minimal: 600 × 800 px</p>
        <p>📄 Format: .JPG atau .PNG</p>
        <p>📦 Ukuran Maksimal: 2 MB</p>
        <p>✅ Background polos atau lingkungan profesional</p>
        <p>❌ Hindari foto buram, filter berlebihan, atau foto grup</p>
        <p className='pt-3'>
          💡 Tips: Gunakan pencahayaan natural dan pakaian formal agar profil Anda terlihat rapi di
          halaman Featured Alumni.
        </p>
      </div>
    </div>
  )
}

const UploadFotoProfile: FC<Props> = ({handleSelectFile}) => {
  return <UploadFotoProfileContent handleSelectFile={handleSelectFile} />
}

export default UploadFotoProfile
